/** User-facing copy for stored CV parse failures (raw errors stay in the API for support). */
export function formatCvParsingErrorMessage(raw?: string | null): string {
  if (!raw?.trim()) {
    return "We couldn't read your CV. Try again or upload a different file."
  }

  const lower = raw.toLowerCase()

  if (
    lower.includes('unsupported_country_region_territory') ||
    lower.includes('country, region, or territory not supported')
  ) {
    return "We couldn't reach our document processing service. Check your connection and try again."
  }

  if (lower.includes('openai_api_key') || lower.includes('not configured')) {
    return "CV processing isn't available right now. Try again later or continue and fill in your profile on the next steps."
  }

  return "We couldn't read your CV. Try again or upload a different file."
}
